export default __webpack_public_path__ + "static/ripple-a30ac2af14f2c3a5461a3105f666d95e.png";